import { z } from "zod";

export const equipmentAssetStatuses = [
  "active",
  "maintenance",
  "retired",
  "sold",
] as const;

export const EquipmentAssetSchema = z.object({
  id: z.string().uuid().describe("ID"),
  business_id: z.string().uuid().describe("Business"),
  account_id: z.string().uuid().describe("Account"),
  equipment_type_id: z.string().uuid().describe("Equipment Type"),
  serial_number: z.string().nullable().describe("Serial Number"),
  purchased_on: z.string().nullable().describe("Purchased On"),
  last_serviced_at: z.string().nullable().describe("Last Serviced At"),
  status: z.enum(equipmentAssetStatuses).describe("Status"),
  notes: z.string().nullable().describe("Notes"),
  created_at: z.string().describe("Created At"),
  updated_at: z.string().describe("Updated At"),
});
export type EquipmentAsset = z.infer<typeof EquipmentAssetSchema>;
